<div class="modal modal-lg fade" id="confirmationModal" tabindex="-1" role="dialog"
    aria-labelledby="confirmationModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered " role="document">
        <div class="modal-content">
            <div class="modal-header">
                <div class="modal-title text-light" id="confirmationModalLabel">Info</div>
                <i class="bi bi-x-circle text-light" style="cursor: pointer" role="button" aria-hidden="true"
                    data-bs-dismiss="modal"></i>

            </div>
            <div class="modal-body">
              <div [innerHTML]="message"></div>
                <div *ngIf="isCorporate || isAdvisor">
                    <div class="" *ngFor="let checkbox of checkboxes">
                        <input type="checkbox" [(ngModel)]="checkbox.checked" (change)="checkCheckbox()"> {{
                        checkbox.label }}
                    </div>
                </div>
                <div *ngIf="isAdvisor" class="mt-2">
                    <div>{{lang.Select_the_following_contacts_to_be_CC_ed}}</div>
                    <div class="d-flex gap-1 row" *ngFor="let checkbox of ccCheckboxes ;  let i = index">
                        <div class="col-5 d-flex gap-1">
                            <input type="checkbox" [(ngModel)]="checkbox.checked" />
                            <span>{{ checkbox.label }}</span>
                        </div>

                    </div>
                    <form [formGroup]="ccForm">
                        <div class="d-flex col-6 gap-2 mt-2">
                            <input type="text" id="email" value={{email}} placeholder="Email"
                                class="form-control checking-field" formControlName="email"
                                (change)="onchange($event)" />
                            <button class="rounded px-3 py-1 border-none" (click)="addEmail()"
                                style="background-color: rgb(93,124,155);border: none;font-size:12px;color: white;">Add</button>

                        </div>


                        <div *ngIf="cc['email'].touched && cc['email'].invalid" class="help-block text-danger">
                            <div *ngIf="cc['email'].errors && cc['email'].errors['pattern']">{{lang.please_enter_valid_email}}
                                </div>
                            <div *ngIf="cc['email'].errors && cc['email'].errors['duplicateMail']">{{lang.Duplicate_Mail}}</div>
                        </div>


                    </form>

                </div>
            </div>

            <div class="modal-footer">
                <div *ngIf="emailError" class="help-block text-danger">
                    <div>
                        {{emailError}}
                    </div>
                </div>
                <button type="button" class="btn btn-secondary cancel-button" (click)="cancel()">Cancel</button>
                <button type="button" class="btn confirm" [disabled]="shouldDisableConfirmButton()" (click)="confirm()">Confirm</button>
            </div>
        </div>
    </div>
</div>
